import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IOrthodonticReferral, IOrthodonticReferralSearchParams, IOrthodonticReferralStatus, IOrthodonticReferralDecision } from "../models/IOrthodonticReferral";
import { ICareProvider } from "../models/ICareProvider";
import { objectToQueryString } from "../helpers/ApiHelper";

export class OrthodonticReferralSearchApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    searchOrthodonticReferrals(searchParams: IOrthodonticReferralSearchParams, success: (data: IPaginatedResponse<IOrthodonticReferral[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch?${queryString}`, success, error, final);
    }

    searchOrthodonticReferralsAsExcel(searchParams: IOrthodonticReferralSearchParams, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch?${queryString}&exportExcel=true`, fileName, success, error, final);
    }

    getOrthodonticReferralStatuses(success: (data: IOrthodonticReferralStatus[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/statuses`, success, error, final);
    }

    getReferrerCareProviders(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/referrerCareProviders`, success, error, final);
    }

    getOrthodonticReferralDecisions(success: (decisions: IOrthodonticReferralDecision[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/orthodonticReferralDecisions`, success, error, final);
    }

    getTreatmentResponsibleCareProviders(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/treatmentResponsibleCareProviders`, success, error, final);
    }

    getConsultantCareProviders(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/consultantCareProviders`, success, error, final);
    }

    getReferrerUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/referrerUmbrellaOrganisations`, success, error, final);
    }

    getReferrerCareProvidersByUmbrellaOrganisationId(umbrellaOrganisationId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/referrerCareProviderByUmbrellaOrganisationId/${umbrellaOrganisationId}`, success, error, final);
    }

    getTreatmentResponsibleUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/treatmentResponsibleUmbrellaOrganisations`, success, error, final);
    }

    getTreatmentResponsibleCareProviderByUmbrellaOrganisationId(umbrellaOrganisationId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralSearch/treatmentResponsibleCareProviderByUmbrellaOrganisationId/${umbrellaOrganisationId}`, success, error, final);
    }


}